<template>
  <div class="Site IndexBox" style="padding-top:0">
    <div v-if="listData" class="ScrollBox">
      <van-nav-bar
        :border="false"
        :title="$docTitle"
        :right-text="$t('Finance[8]')"
        style="background:transparent"
        @click-right="$router.push('/financeOrder')"
      >
      </van-nav-bar>
      <div v-if="listData.length" class="finance-list">
        <router-link v-for="item,index in listData" :key="index" :to="`/financeDetail/${item.id}`" :class="{gray: item.state==3}">
          <div style="position:relative;border-radius: 6px;overflow:hidden">
            <van-image
              width="100%"
              height="130"
              lazy-load
              :src="InitData.setting.up_url+item.cover_img"
              style="display:block"
            />
            <div class="mark" v-if="item.state==3">
              <img :src="`./static/icon/${$i18n.locale}/finance_state${item.state}.png`" height="90">
            </div>
          </div>
          <div class="title">
            <h4>{{item.title}}</h4>
          </div>
          <div class="info">
            <div class="left">
              <div v-if="item.daily_dividend">
                <label>{{$t('Finance[0][0]')}}</label>
                <span v-if="item.profit_multiple">{{Number(item.daily_dividend)}} x {{Number(item.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(item.daily_dividend)*Number(item.profit_multiple),2)}}</span>
                <span v-else>{{InitData.currency}}{{Number(item.daily_dividend)}}</span>
              </div>
              <div v-if="item.equity">
                <label>{{$t('Finance[0][1]')}}</label>
                <span v-if="item.profit_multiple">{{Number(item.equity)}} x {{Number(item.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(item.equity)*Number(item.profit_multiple),2)}}</span>
                <span v-else>{{InitData.currency}}{{Number(item.equity)}}</span>
              </div>
              <div v-if="item.options">
                <label>{{$t('Finance[0][2]')}}</label>
                <span v-if="item.profit_multiple">{{Number(item.options)}} x {{Number(item.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(item.options)*Number(item.profit_multiple),2)}}</span>
                <span v-else>{{InitData.currency}}{{Number(item.options)}}</span>
              </div>
              <div v-if="item.subsidy">
                <label>{{$t('Finance[0][3]')}}</label>
                <span v-if="item.profit_multiple">{{Number(item.subsidy)}} x {{Number(item.profit_multiple)}} {{$t('Finance[0][4]')}} = {{InitData.currency}}{{$Util.KeepDecimal(Number(item.subsidy)*Number(item.profit_multiple),2)}}</span>
                <span v-else>{{InitData.currency}}{{Number(item.subsidy)}}</span>
              </div>
              <van-progress :percentage="item.schedule" stroke-width="12" color="var(--color-active)" />
            </div>
            <div class="right">
              <img v-if="item.hot==1" :src="`./static/icon/icon-hot.png`" width="50">
              <van-button v-if="item.state==1" type="danger" size="small" round>{{$t('Finance[1]')}}</van-button>
            </div>
          </div>
        </router-link>
      </div>
      <van-empty v-else :image="`./static/icon/no_data.png`" :description="$t('vanPull[1]')" />
    </div>
    <van-loading v-else size="60px" vertical style="margin-top: 50%">{{$t('dialog[6]')}}</van-loading>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'Finance',
  components: {

  },
  props: [],
  data() {
    return {
      listData: ''
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getListData()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    getListData() {
      this.$Model.GetFinanceList(data=>{
        if(data.code==1){
          this.listData = data.list
        }else{
          this.listData = []
        }
      })
    }
  }
}
</script>
<style scoped>
.finance-list {
  padding: 12px;
}
.finance-list>a{
  display: block;
  border-radius: 10px;
  overflow: hidden;
  padding: 10px;
  margin-bottom: 15px;
  line-height: 1;
  box-shadow: 0 0 5px rgba(252, 95, 53, .5);
}
.finance-list>a.gray{
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.finance-list .mark{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, .5);
}
.finance-list .title{
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.finance-list .title h4{
  font-size: 16px;
  font-weight: 600;
}
.finance-list .info{
  display: flex;
  margin-top: 10px;
}
.finance-list .left{
  flex: 1;
  margin-right: 30px;
}
.finance-list .left label{
  max-width: 70px;
  margin-right: 5px;
}
.finance-list .left>div{
  margin-top: 8px;
  display: flex;
}
.finance-list .right{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.finance-list .right .van-button{
  margin-top: 10px;
}
.van-progress{
  border-radius: 50px;
  margin-top: 10px!important;
}
.van-progress>>>.van-progress__pivot{
  line-height: 1;
}
</style>